import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueMoment from 'vue-moment';
import 'leaflet/dist/leaflet.css';
import axios from "axios";

import(`@/assets/${process.env.SITE}.css`);

Vue.config.productionTip = false;

// configure auth
axios.defaults.headers.common["Authorization"] = window.sessionStorage.getItem("auth-header");
axios.interceptors.response.use((response) => {
  return response
}, async (error) => {
  if (router.currentRoute.name !== 'login' && error.response?.status === 401) {
    await router.replace({ name: 'login', query: {"next": router.currentRoute.name} });
  }
  return error;
});

Vue.filter('sort', <T, K extends keyof T>(as: T[], ...keys: K[]): T[] => {
  return as.slice().sort((a1, a2) => {
    for (const k of keys) {
      if (a1[k] < a2[k]) {
        return -1;
      }
      if (a1[k] > a2[k]) {
        return 1;
      }
    }
    return 0;
  });
});

// N.B: Report table defines its own formats and doesn't use these because it does something slightly different with
// currencies, i.e. they don't display the '£' sign.
const NUMBER_FORMAT = Intl.NumberFormat('en-GB', { style: 'decimal' });
const PERCENT_FORMAT = Intl.NumberFormat('en-GB', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});
const CURRENCY_FORMAT = Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
const CURRENCY_WITH_PENCE_FORMAT = Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

Vue.filter('number', (x: number, dashForZero = false) =>
  // Yes, x should be a number, but sometimes it's a string. Woop.
  (parseFloat(x.toString()) === 0 && dashForZero) ? '-' : NUMBER_FORMAT.format(x));
Vue.filter('currency', (x: number, dashForZero = false) =>
  (parseFloat(x.toString()) === 0 && dashForZero) ? '-' : CURRENCY_FORMAT.format(x));
Vue.filter('currencyWithPence', (x: number, dashForZero = false) =>
  (parseFloat(x.toString()) === 0 && dashForZero) ? '-' : CURRENCY_WITH_PENCE_FORMAT.format(x));
Vue.filter('percent', (x: number, dashForZero = false) =>
  (parseFloat(x.toString()) === 0 && dashForZero) ? '-' : PERCENT_FORMAT.format(x));
Vue.use(VueMoment);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');

export function range(start: number, stop: number, step: number = 1) {
  return Array.from(
    { length: (stop - start) / step + 1 },
    (_, i) => start + (i * step),
  );
}
